import * as _ from 'lodash'
import React from 'react';
import * as actions from '../actions';
import util from '../util';
import keyboardUtil from 'Scripts/keyboardUtils';
import valueFilters from '../valueFilters';
import jobCostPaymentTermFactory from '../models/jobCostPaymentTermModel';
import { CurrencyInput, Popup } from './sharedComponents';

const KEY_DOWN_CODES = [13];
class TermsSection extends React.Component<any,any> {
	private _pendingTerm;

	constructor (props) {
		super(props);

		this.state = { addClicked: false, changeCount: 0 };

		this._pendingTerm = jobCostPaymentTermFactory({ key: util.generateGuid(), sortIndex: 0 });

		this.handleAddClick = this.handleAddClick.bind(this);
		this.handleCalculateClick = this.handleCalculateClick.bind(this);
	}

	handleAddClick () {
		const { terms, onTermsChange } = this.props;
		const valid = this.validate(this._pendingTerm);

		if (!valid) {
			this.setState({ addClicked: true });
		}
		else {
			const toAdd = this._pendingTerm;
			const newTerms:any[] = [].concat(terms);

			this._pendingTerm = jobCostPaymentTermFactory({ key: util.generateGuid(), sortIndex: 0 });

			_.forEach(newTerms, t => {
				t.sortIndex += 1;
			});

			newTerms.unshift(toAdd);

			onTermsChange(newTerms);
			this.setState({ addClicked: false });
		}
	}

	handleCalculateClick () {
		this.props.calculateTerms(true);
	}

	validate (term, property?) {
		if (!property || term !== this._pendingTerm || this.state.addClicked) {
			const result = !term.test(property);

			return result;
		}
		return true;
	}

	handleContextMenuClicked (key, e) {
		const { terms, onTermsChange } = this.props;

		e.preventDefault();

		const handleClick = () => {
			const newTerms = _.sortBy(_.filter(terms, t => t.key !== key), ['sortIndex']);
			let sortIndex = 0;

			_.forEach(newTerms, t => {
				t.sortIndex = sortIndex++;
			});

			onTermsChange(newTerms);
			setTimeout(actions.popModal, 0);
		};

		const content = (<div className="content scrollable">
			<ul className="menu">
				<li><a className="button icon iconLabel removeItem delete" onClick={ handleClick }><span>Delete</span></a></li>
			</ul>
		</div>);

		const popup = <Popup target={e.target}>{ content }</Popup>;
		actions.pushModal({ component: popup });
	}

	updateModel (key, property, e) {
		const { terms, onTermsChange, minAmount } = this.props;
		const term = _.find(terms, { key: key }) || this._pendingTerm;
		let newVal = e.type === 'change' ? e.target.value : valueFilters.clean(e.target.value);

		if (property === 'amountDue' && Number(newVal) < minAmount.toFixed(2)) {
			newVal = minAmount.toString();
		}

		term.setAt(property, newVal);

		if (term !== this._pendingTerm) {
			onTermsChange([].concat(terms));
		}
		else {
			this.setState({ changeCount: this.state.changeCount + 1 });
		}
	}

	render () {
		const { canAdd, canEdit, className, isLocked, terms } = this.props;
		const _pendingTerm = this._pendingTerm;
		let rowCount = 0;

		const rows = _.map(_.sortBy(terms, ['sortIndex']), term => {
			rowCount++;

			return (<tr key={ term.key } className="added">
				<td />
				<td className="count"><span className="readOnly"><strong>{ rowCount }</strong></span></td>
				<td className={(!this.validate(term, 'description') ? 'required' : '')}>
					<input type="text" placeholder="Enter a Description" autoCapitalize="" autoCorrect="off" 
						value={ term.viewValue('description') } 
						onChange={ this.updateModel.bind(this, term.key, 'description') } 
						onBlur={ this.updateModel.bind(this, term.key, 'description') } 
						onKeyDown={(e) => keyboardUtil.onKeyDownCallback(e, KEY_DOWN_CODES, () => this.handleContextMenuClicked(term.key, e))}/>
				</td>
				<td className={(!this.validate(term, 'amountDue') ? 'cost required' : 'cost')}>
					<CurrencyInput placeholder="0" value={ term.viewValue('amountDue') } 
						onChange={ this.updateModel.bind(this, term.key, 'amountDue') } 
						onBlur={ this.updateModel.bind(this, term.key, 'amountDue') } 
						onKeyDown={(e) => keyboardUtil.onKeyDownCallback(e, KEY_DOWN_CODES, () => this.handleContextMenuClicked(term.key, e))}/></td>
				<td>{ canAdd ? <button className="icon iconOnly contextMenu" onClick={ this.handleContextMenuClicked.bind(this, term.key) }><span /></button> : null }</td>
				<td />
			</tr>);
		});

		if (!isLocked && !!canAdd) {
			rows.unshift(<tr key="addRow" className="addRow">
				<td />
				<td className="count"><span className="readOnly"><strong>-</strong></span></td>
				<td className={(!this.validate(_pendingTerm, 'description') ? 'required' : '')}>
					<input type="text" placeholder="Enter a Description" autoCapitalize="" autoCorrect="off" 
						value={ _pendingTerm.viewValue('description') } 
						onChange={ this.updateModel.bind(this, _pendingTerm.key, 'description') } 
						onBlur={ this.updateModel.bind(this, _pendingTerm.key, 'description') }
						onKeyDown={(e) => keyboardUtil.onKeyDownCallback(e, KEY_DOWN_CODES, this.handleAddClick)} />
				</td>
				<td className={(!this.validate(_pendingTerm, 'amountDue') ? 'cost required' : 'cost')}>
					<CurrencyInput placeholder="0" value={ _pendingTerm.viewValue('amountDue') } 
						onChange={ this.updateModel.bind(this, _pendingTerm.key, 'amountDue') } 
						onBlur={ this.updateModel.bind(this, _pendingTerm.key, 'amountDue') } 
						onKeyDown={(e) => keyboardUtil.onKeyDownCallback(e, KEY_DOWN_CODES, this.handleAddClick)}/>
				</td>
				<td><button className="icon iconOnly addItem" onClick={ this.handleAddClick }><span /></button></td>
				<td />
			</tr>);
		}

		const calculateButton = !isLocked ? <button onClick={ this.handleCalculateClick }><span>Calculate</span></button> : null;

		return (<section className={ className }>
			<header>
				<span>TERMS</span>
				<div className="actions">
					{ calculateButton }
				</div>
			</header>
			<div>
				<div className={'inner' + (isLocked || !canEdit ? ' readOnly' : '')}>
					<table className="compact terms" cellPadding="0" cellSpacing="0">
						<thead>
							<tr>
								<td />
								<td className="count">Payment No.</td>
								<td>Description</td>
								<td className="cost">Due</td>
								<td />
								<td />
							</tr>
						</thead>
						<tbody>
							{ rows }
						</tbody>
					</table>
				</div>
			</div>
		</section>);
	}
}

const BalanceSection = ({ className, isLocked, contractAmount, paymentAmount, termAmount, balance }) => {
	const paymentRow = (typeof paymentAmount === 'undefined') ? null : (
		<tr>
			<td />
			<td>Payments Applied</td>
			<td className="cost">{ util.formatAsCurrency(paymentAmount) }</td>
			<td />
		</tr>);

	return (<section className={ className }>
		<header className="">
			<span>BALANCE</span>
		</header>
		<div>
			<div className={'inner' + (isLocked ? ' readOnly' : '')}>
				<table className="balance" cellPadding="0" cellSpacing="0">
					<tbody>
						<tr>
							<td />
							<td>Contract Amount</td>
							<td className="cost">{ util.formatAsCurrency(contractAmount) }</td>
							<td />
						</tr>
						{ paymentRow }
						<tr>
							<td />
							<td>Terms Total</td>
							<td className="cost">{ util.formatAsCurrency(termAmount) }</td>
							<td />
						</tr>
					</tbody>
					<tfoot className={ 'subtotal' + (Math.abs(balance) !== 0 ? ' invalid' : '') }>
						<tr>
							<td />
							<td className="right">Balance</td>
							<td className="cost">{ util.formatAsCurrency(balance) }</td>
							<td />
						</tr>
					</tfoot>
				</table>
			</div>
		</div>
	</section>);
};

export { BalanceSection, TermsSection };